module.exports = __webpack_public_path__ + "img/santa-and-babu-2.b402334e.png";